import { validCNPJ, validCPF } from "core/functions/validations";
import * as Yup from "yup";


export const supplierRegistrationSchema = Yup.object({
  nameUser: Yup.string().required("Campo obrigatório"),
  cpf: Yup.string()
    .required(" ")
    .test("min-digits", " ", (value) => {
      if (value && value.replace(/[^\d]+/g, "").length < 11) {
        return false;
      }
      return true;
    })
    .test("valid-cpf", "CPF inválido", (value) => {
      if (value && value.replace(/[^\d]+/g, "").length === 11) {
        return validCPF(value);
      }
      return true;
    }),
  name: Yup.string().required("Campo obrigatório"),
  cnpj: Yup.string()
    .required("Campo obrigatório")
    .test("min-digits", " ", (value) => {
      if (value && value.replace(/[^\d]+/g, "").length < 14) {
        return false;
      }
      return true;
    })
    .test("valid-cnpj", "CNPJ inválido", (value) => {
      if (value && value.replace(/[^\d]+/g, "").length === 14) {
        return validCNPJ(value);
      }
      return true;
    }),
  phone: Yup.string()
    .required("Telefone é obrigatório")
    .max(15, "Telefone deve ter no máximo 15 caracteres")
    .matches(/^\(\d{2}\)\s9\d{4}-\d{4}$/, "Telefone inválido. Deve estar no formato (XX) 9XXXX-XXXX"),
  
  email: Yup.string().email("Email inválido").required("Campo obrigatório"),
  fantasyName: Yup.string().required("Campo obrigatório"),
  password: Yup.string().required("Campo obrigatório"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), ""], "As senhas devem ser iguais")
    .required("Campo obrigatório"),
});
